export const languageList = [
    'English',
    'Abkhaz',
    'Adyghe',
    'Afrikaans',
    'Akan',
    'Albanian',
    'American Sign Language',
    'Amharic',
    'Arabic',
    'Aragonese',
    'Aramaic',
    'Armenian',
    'Assamese',
    'Aymara',
    'Balinese',
    'Basque',
    'Betawi',
    'Bosnian',
    'Breton',
    'Bulgarian',
    'Cantonese',
    'Catalan',
    'Cherokee',
    'Chickasaw',
    'Chinese',
    'Coptic',
    'Cornish',
    'Corsican',
    'Crimean Tatar',
    'Croatian',
    'Czech',
    'Danish',
    'Dutch',
    'Dawro',
    'Esperanto',
    'Estonian',
    'Ewe',
    'Fiji Hindi',
    'Filipino',
    'Finnish',
    'French',
    'Galician',
    'Georgian',
    'German',
    'Greek, Modern',
    'Ancient Greek',
    'Greenlandic',
    'Haitian Creole',
    'Hawaiian',
    'Hebrew',
    'Hindi',
    'Hungarian',
    'Icelandic',
    'Indonesian',
    'Inuktitut',
    'Interlingua',
    'Irish',
    'Italian',
    'Japanese',
    'Javanese',
    'Kabardian',
    'Kalasha',
    'Kannada',
    'Kashubian',
    'Khmer',
    'Kinyarwanda',
    'Korean',
    'Kurdish/Kurdî',
    'Ladin',
    'Latgalian',
    'Latin',
    'Lingala',
    'Livonian',
    'Lojban',
    'Lower Sorbian',
    'Low German',
    'Macedonian',
    'Malay',
    'Malayalam',
    'Mandarin',
    'Manx',
    'Maori',
    'Mauritian Creole',
    'Middle English',
    'Middle Low German',
    'Min Nan',
    'Mongolian',
    'Norwegian',
    'Old Armenian',
    'Old English',
    'Old French',
    'Old Javanese',
    'Old Norse',
    'Old Prussian',
    'Oriya',
    'Pangasinan',
    'Papiamentu',
    'Pashto',
    'Persian',
    'Pitjantjatjara',
    'Polish',
    'Portuguese',
    'Proto-Slavic',
    'Quenya',
    'Rajasthani',
    'Rapa Nui',
    'Romanian',
    'Russian',
    'Sanskrit',
    'Scots',
    'Scottish Gaelic',
    'Semai',
    'Serbian',
    'Serbo-Croatian',
    'Slovak',
    'Slovene',
    'Spanish',
    'Sinhalese',
    'Swahili',
    'Swedish',
    'Tagalog',
    'Tajik',
    'Tamil',
    'Tarantino',
    'Telugu',
    'Thai',
    'Tok Pisin',
    'Turkish',
    'Twi',
    'Ukrainian',
    'Upper Sorbian',
    'Urdu',
    'Uyghur',
    'Uzbek',
    'Venetian',
    'Vietnamese',
    'Vilamovian',
    'Volapük',
    'Võro',
    'Welsh',
    'Xhosa',
    'Yiddish',
    'Zazaki',
    'Zulu',
];

export const primaryCampusList = [
    'Burnaby',
    'Vancouver',
    'Surrey',
];

export const TINYMCE_EDITOR_HTML_STRING_LIMIT: number = 5000;

export const RESEARCHER_PREFERRED_FIRST_NAME_MAX_LENGTH = 255;
export const RESEARCHER_PREFERRED_LAST_NAME_MAX_LENGTH = 255;
export const RESEARCHER_PREFERRED_EMAIL_MAX_LENGTH = 255;
export const RESEARCHER_PREFERRED_PRONOUNS_MAX_LENGTH = 20;
export const RESEARCHER_NOTE_MAX_LENGTH = 1000;
export const RESEARCHER_INTERESTS_MAX_LENGTH = 1000;
export const RESEARCHER_SFU_LINK_MAX_LENGTH = 255;
export const MY_PROFILE_WITH_SHOW_TO_PUBLIC_SET_TO_FALSE = 'MY_PROFILE_WITH_SHOW_TO_PUBLIC_SET_TO_FALSE';
